import { CashOnDeliveriesI } from '../interfaces/cash_on_deliveries.interface'
import { CashOnDeliveriesService } from '../services/cash_on_deliveries.service'
import {
    CashOnDeliveriesExcelParams,
    CashOnDeliveriesExcelResponse,
    CashOnDeliveriesParams,
    CashOnDeliveriesResponse,
    UpdateCashOnDeliveriesPayload,
} from '../types/cash_on_deliveries.types'

const cashOnDeliveriesService = new CashOnDeliveriesService()

class CashOnDeliveriesRealisation implements CashOnDeliveriesI {
    getList(params: CashOnDeliveriesParams): Promise<CashOnDeliveriesResponse> {
        return cashOnDeliveriesService.getList(params)
    }

    exportExcel(params: CashOnDeliveriesExcelParams): Promise<CashOnDeliveriesExcelResponse> {
        return cashOnDeliveriesService.exportExcel(params)
    }

    updateCashOnDeliveries(params: UpdateCashOnDeliveriesPayload): Promise<void> {
        return cashOnDeliveriesService.updateCashOnDeliveries(params)
    }
}

export const cash_on_deliveries = new CashOnDeliveriesRealisation()
